import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import { Toaster } from "./components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                theme="light"
                position="top-right"
                toastOptions={{
                    style: {
                        background: "#ffffff",
                        border: "1px solid #e5e5e5",
                        color: "#0a0a0a",
                    },
                }}
            />
        </div>
    );
}

export default App;
